export const ImportSelectorRegex = /ImportSelector\((?:"[^"]*"|[^)])*\)/g;
export const vslParamsRegex = /[\w\s_]+="?[\w\s()]+"?/g;
export const LineItemTagSelectorType = "Line Item Tag";
export const AbsolutePeriodSelectorType = "Absolute Period";
export const RelativePeriodSelectorType = "Relative Periods";
export const widgetTitleVariablesRegex = /__.+?__/g;
